import { createSlice } from '@reduxjs/toolkit';
import { athkarEsbahWMasaa } from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';



const card = athkarEsbahWMasaa.data.filter(card => card.type === "masaa" || card.type === "all");
const modifiedCards = card.map(card => ({
  ...card,
  id: `${card.id}-masaa`
}));


const athkarElmasaaSlice = createSlice({
  name: 'athkarElmasaa',
  initialState: {
    value: 0,
    data: modifiedCards,
  },
  reducers: {
    showInfoM: showInfoAct,
    numDecreaseM: numDecreaseAct,
    prograssNumM:prograssNum
  },
});

export const { showInfoM, numDecreaseM,prograssNumM } = athkarElmasaaSlice.actions;
export default athkarElmasaaSlice.reducer;